import { hotTopics } from "../../../mocks/communityData";

export default function HotTopics() {
  return (
    <section id="hot" className="mx-auto w-full max-w-6xl scroll-mt-20 px-4 py-14 md:px-6">
      {/* 标题 */}
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-primary-500">
            <i className="ri-fire-line" /> Hot Now
          </span>
          <h2 className="mt-2 font-display text-3xl text-foreground-900 md:text-4xl">今日瓜榜 TOP8</h2>
          <p className="mt-2 text-foreground-600">大家都在围观什么？看看有没有你也在追的那一个。</p>
        </div>
        <a href="#news" className="flex items-center gap-1 text-sm font-semibold text-primary-500 hover:text-primary-600 whitespace-nowrap">
          查看全部瓜料 <i className="ri-arrow-right-line" />
        </a>
      </div>

      {/* 榜单 */}
      <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {hotTopics.map((t) => (
          <div
            key={t.id}
            className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition hover:border-primary-200 hover:bg-background-100"
          >
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-display text-lg ${
                t.rank <= 3
                  ? "bg-primary-500 text-white"
                  : t.rank <= 5
                    ? "bg-secondary-400 text-white"
                    : "bg-background-200 text-foreground-600"
              }`}
            >
              {t.rank}
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-500">{t.title}</p>
              <div className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-fire-fill text-primary-400" /> {t.heat}
                </span>
                {t.trend === "up" && <i className="ri-arrow-up-line text-primary-500" />}
                {t.trend === "down" && <i className="ri-arrow-down-line text-foreground-400" />}
                {t.trend === "flat" && <i className="ri-subtract-line text-foreground-400" />}
              </div>
            </div>
            <a
              href="#news"
              aria-label={`进入话题：${t.title}`}
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-foreground-400 opacity-0 transition group-hover:bg-background-50 group-hover:text-primary-500 group-hover:opacity-100"
            >
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}